class Switching {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(function () {
      $(".js-sub-img img").on("click", function () {
        const img = $(this).attr("src");
        $(".js-sub-img li").removeClass("current");
        $(this).parent().addClass("current");
        $(".js-main-img img").fadeOut(500, function () {
          $(".js-main-img img")
            .attr("src", img)
            .on("load", function () {
              $(this).fadeIn();
            });
        });
      });
    });    
  }
}
